<template>
  <div class="tm-showcase">
    <div class="tm-showcase-top">
      <span class="tm-preview-wordmark"
        ><img src="/logo.png" width="14" height="14" alt="" aria-hidden="true" />TradingCandle<span
          class="tm-preview-example"
          >Example workspace</span
        ></span
      ><span class="tm-window-dots"><i></i><i></i><i></i></span>
    </div>
    <div class="tm-showcase-toolbar">
      <span class="tm-market-symbol">BTC / USDT <small>BINANCE</small></span>
      <div class="tm-preview-timeframes">
        <span>15m</span><span class="active">1H</span><span>4H</span
        ><span>1D</span>
      </div>
      <span class="tm-preview-indicator"
        ><MarketingIcon name="indicator" :size="15" /> Indicators</span
      ><span class="tm-preview-layout"
        ><MarketingIcon name="grid" :size="15"
      /></span>
    </div>
    <div class="tm-showcase-body">
      <aside class="tm-preview-tools">
        <MarketingIcon
          v-for="icon in [
            'chart',
            'drawing',
            'layers',
            'indicator',
            'replay',
            'alert',
          ]"
          :key="icon"
          :name="icon"
          :size="17"
        />
      </aside>
      <div class="tm-preview-chart">
        <div class="tm-preview-quote">
          <span>Bitcoin / TetherUS <small>· 1 hour</small></span
          ><strong>67,842<span>.50</span><em>+2.34%</em></strong
          ><small>{{
            mode === "Visual Trading"
              ? "VT · Visual candles · Targets · Confidence"
              : mode === "Replay"
                ? "Bar replay · Practice your next move"
                : "Price · Moving average · Volume"
          }}</small>
        </div>
        <svg
          viewBox="0 0 800 340"
          role="img"
          aria-label="Illustrative Bitcoin candlestick chart with a rising trend. Sample data, not a live market feed."
        >
          <defs>
            <linearGradient id="tm-area-fill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#278e74" stop-opacity=".14" />
              <stop offset="100%" stop-color="#278e74" stop-opacity="0" />
            </linearGradient>
          </defs>
          <g stroke="currentColor" opacity=".065">
            <path
              v-for="y in [45, 100, 155, 210, 265]"
              :key="'y' + y"
              :d="'M0 ' + y + 'H738'"
            />
            <path
              v-for="x in [60, 190, 320, 450, 580, 710]"
              :key="'x' + x"
              :d="'M' + x + ' 0V302'"
            />
          </g>
          <path :d="areaPath" fill="url(#tm-area-fill)" />
          <path
            :d="averagePath"
            fill="none"
            stroke="#d8a856"
            stroke-width="1.7"
            opacity=".85"
          />
          <g
            v-for="(bar, index) in shownBars"
            :key="index"
            :stroke="bar.up ? '#268b72' : '#c96b65'"
            :fill="bar.up ? '#268b72' : '#c96b65'"
          >
            <path
              :d="'M' + bar.x + ' ' + bar.high + 'V' + bar.low"
              stroke-width="1"
            />
            <rect
              :x="bar.x - 3.5"
              :y="Math.min(bar.open, bar.close)"
              width="7"
              :height="Math.max(2, Math.abs(bar.close - bar.open))"
              rx=".6"
              stroke="none"
            />
            <rect
              :x="bar.x - 3.5"
              :y="315 - bar.volume"
              width="7"
              :height="bar.volume"
              stroke="none"
              opacity=".15"
            />
          </g>
          <g v-if="mode === 'Visual Trading'">
            <path
              d="M55 219H279 M279 166H469 M469 111H724"
              fill="none"
              stroke="#268b72"
              stroke-width="1.5"
              stroke-dasharray="4 4"
            />
            <rect
              x="136"
              y="244"
              width="39"
              height="20"
              rx="5"
              fill="#17644e"
            />
            <text
              x="155.5"
              y="258"
              text-anchor="middle"
              fill="white"
              font-size="10"
            >
              BUY
            </text>
            <path d="M155 243l-4-5h8z" fill="#17644e" />
            <rect x="584" y="93" width="70" height="20" rx="5" fill="#e9f5ee" />
            <text
              x="619"
              y="107"
              text-anchor="middle"
              fill="#17644e"
              font-size="10"
            >
              VT TARGET
            </text>
          </g>
          <g
            fill="currentColor"
            opacity=".4"
            font-size="9"
            font-family="Arial,sans-serif"
          >
            <text x="751" y="48">69,000</text>
            <text x="751" y="103">68,000</text>
            <text x="751" y="158">67,000</text>
            <text x="751" y="213">66,000</text>
            <text x="751" y="268">65,000</text>
            <text x="55" y="333">08:00</text>
            <text x="185" y="333">12:00</text>
            <text x="315" y="333">16:00</text>
            <text x="445" y="333">20:00</text>
            <text x="575" y="333">00:00</text>
            <text x="705" y="333">04:00</text>
          </g>
          <path
            d="M0 128H738"
            stroke="#268b72"
            stroke-dasharray="3 4"
            opacity=".5"
          />
          <rect x="741" y="119" width="58" height="18" rx="3" fill="#17644e" />
          <text x="770" y="131" text-anchor="middle" fill="white" font-size="9">
            67,842.50
          </text>
        </svg>
        <div class="tm-preview-bottom">
          <span><MarketingIcon name="replay" :size="12" /> Replay</span
          ><span>Compare</span><span>Alert</span
          ><span class="tm-preview-clock">UTC · Sample data</span>
        </div>
      </div>
      <aside class="tm-preview-watchlist">
        <strong>Watchlist <span>+</span></strong>
        <div
          v-for="asset in assets"
          :key="asset.name"
          :class="{ selected: asset.name === 'BTCUSDT' }"
        >
          <span
            >{{ asset.name }}<small>{{ asset.label }}</small></span
          ><b
            >{{ asset.price }}<small>{{ asset.change }}</small></b
          >
        </div>
        <div class="tm-mini-note">
          <MarketingIcon name="layers" :size="18" /><span
            >Your perspective.<br /><strong>All in one place.</strong></span
          >
        </div>
      </aside>
    </div>
    <div class="tm-preview-modes" aria-label="Chart preview mode">
      <button
        v-for="tab in ['Charting', 'Visual Trading', 'Replay']"
        :key="tab"
        :class="{ active: mode === tab }"
        @click="mode = tab"
        :aria-pressed="mode === tab"
      >
        {{ tab }}</button
      ><span>Illustrative preview</span>
    </div>
  </div>
</template>
<script>
import MarketingIcon from "./MarketingIcon.vue";
export default {
  components: { MarketingIcon },
  data: () => ({
    mode: "Visual Trading",
    assets: [
      {
        name: "BTCUSDT",
        label: "Bitcoin",
        price: "67,842.50",
        change: "+2.34%",
      },
      {
        name: "ETHUSDT",
        label: "Ethereum",
        price: "3,521.80",
        change: "+1.82%",
      },
      { name: "SOLUSDT", label: "Solana", price: "148.25", change: "+3.15%" },
      { name: "BNBUSDT", label: "BNB", price: "592.40", change: "+0.91%" },
    ],
  }),
  computed: {
    bars() {
      return Array.from({ length: 65 }, (_, i) => {
        const mid =
          236 - i * 1.9 + Math.sin(i * 0.32) * 24 + Math.sin(i * 0.91) * 10;
        const open = mid + Math.sin(i * 2.5) * 8,
          close = mid + Math.cos(i * 1.7) * 9;
        return {
          x: 15 + i * 11,
          open,
          close,
          high: Math.min(open, close) - 5 - Math.abs(Math.sin(i)) * 8,
          low: Math.max(open, close) + 4 + Math.abs(Math.cos(i)) * 9,
          up: close < open,
          volume: 7 + Math.abs(Math.sin(i * 0.6)) * 20,
        };
      });
    },
    shownBars() {
      return this.mode === "Replay" ? this.bars.slice(0, 46) : this.bars;
    },
    averagePath() {
      return this.shownBars
        .map(
          (b, i) =>
            (i ? "L" : "M") +
            b.x +
            "," +
            (250 - i * 1.7 + Math.sin(i * 0.18) * 10),
        )
        .join(" ");
    },
    areaPath() {
      const bars = this.shownBars;
      return (
        "M" +
        bars[0].x +
        ",305 " +
        bars.map((b) => "L" + b.x + "," + b.close).join(" ") +
        " L" +
        bars.at(-1).x +
        ",305 Z"
      );
    },
  },
};
</script>
